import bltHome from './slice/bltHomeSlice'
import bltReview from './slice/bltReviewSlice'
import bltChangeReview from './slice/bltChangeReviewSlice'

export default function bltComponentsReducer(state = {}, action) { 
    state = Object.assign({},state, {bltHome : bltHome(state.bltHome, action)})
    state = Object.assign({}, state, {bltReview : bltReview(state.bltReview, action)})
    state = Object.assign({}, state, {bltChangeReview : bltChangeReview(state.bltChangeReview, action)})

    return state
}